var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTurnRightArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 34,
    rx: 16.5,
    stroke: "#0052B4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4501_5816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8963 16.4956C25.6404 15.438 24.5828 14.1821 23.4591 12.9923C22.8642 12.3644 21.9389 11.1085 20.9474 11.0424C20.8813 10.9433 20.7821 10.8772 20.5508 10.9102C20.4186 10.9433 20.3194 11.0424 20.2864 11.1746C20.0881 11.9347 20.1211 12.7279 20.1211 13.5211C17.2128 13.1245 13.8086 14.5787 11.4952 16.132C8.95033 17.8175 6.96736 20.6268 7.00041 23.7664C7.00041 23.8986 7.09956 23.9647 7.1987 23.9978C7.29785 24.0969 7.43005 24.13 7.56225 24.0639C11.396 21.3538 15.395 18.9743 20.2533 19.8005H20.2863C19.9889 20.759 19.9559 21.8496 19.9559 22.8411C19.9559 23.1385 20.2203 23.2377 20.4185 23.2046C20.5177 23.3368 20.749 23.4359 20.9143 23.2707C23.0956 21.453 25.4751 19.4039 26.9293 16.9253C27.0285 16.8261 27.0285 16.5947 26.8963 16.4956ZM25.8056 17.3879C25.2438 18.2142 24.5167 18.9412 23.7896 19.6683C22.7981 20.6598 21.6744 21.5191 20.716 22.5437C20.716 21.6513 20.683 20.759 20.749 19.8335C20.749 19.7344 20.716 19.6683 20.6499 19.6352C20.749 19.4369 20.716 19.1726 20.4516 19.1064C15.6593 18.0819 11.2307 20.3623 7.5292 23.2707C8.02494 20.3623 9.74352 18.1811 12.2222 16.5286C14.701 14.8761 17.2789 14.5456 20.1211 14.2151V14.2482C20.0881 14.5126 20.5177 14.5456 20.5838 14.3143C20.5838 14.2482 20.6168 14.2151 20.6168 14.149C20.8151 14.0499 20.8812 13.7855 20.716 13.6863C20.8151 13.1575 20.8482 12.6287 20.9143 12.0999C20.9143 12.0008 20.9473 11.8355 20.9804 11.6703C21.4101 12.2321 22.1372 12.7279 22.6329 13.2236C23.5913 14.2151 24.4837 15.2727 25.4752 16.2642C26.0039 16.7269 26.2352 16.7269 25.8056 17.3879Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4501_5816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 7.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTurnRightArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/turn-right-arrow.6d8cff04.svg";
export { ForwardRef as ReactComponent };